export const focusAtEnd = (element: HTMLElement | null): void => {
  if (!element) return
  element.focus()
  try {
    const range = document.createRange()
    const selection = window.getSelection()
    range.selectNodeContents(element)
    range.collapse(false)
    selection?.removeAllRanges()
    selection?.addRange(range)
  } catch (error) {
    console.warn(error)
  }
}
